export function setVideoFoPiP(videoData) {
    return function (dispatch) {
        dispatch({
            type: "SET_PIP_VIDEO",
            payload: videoData
        })
    }
}
